<template>
    <section>
        <b-card v-if="_products && _products.length === 0">
            <div class="text-muted">
                Kayıt bulunamadı.
            </div>
        </b-card>

        <div
            v-for="(product, pIndex) in _products"
            :key="product.id"
        >
            <b-card>
                <ProductMatchProduct
                    v-for="(tyProduct, tyIndex) in product.ty_all_products"
                    :key="tyIndex"
                    :ty-product="tyProduct"
                    :ty-index="tyIndex"
                    :product="product"
                    :p-index="pIndex"
                    :store-product="{}"
                />
            </b-card>
        </div>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ProductMatchProduct from './ProductMatchProduct.vue'

    export default {
        name: 'ProductMatchProducts',
        components: {
            ProductMatchProduct,
        },
        computed: {
            ...mapGetters('tyProductMatch', ['_products']),
        },
    }
</script>
